import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Component that tracks referral visits when someone arrives via a ?ref= link.
 * Also stores the ref code in sessionStorage for potential signup bonus tracking.
 */
const ReferralTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackReferral = async () => {
      const params = new URLSearchParams(location.search);
      const refCode = params.get('ref');
      
      if (!refCode) return;
      
      // Check if we already tracked this session
      const trackedRef = sessionStorage.getItem('tracked_referral');
      if (trackedRef === refCode) return;
      
      try {
        const response = await fetch(`${API_URL}/api/referrals/track-visit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ref_code: refCode }),
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            // Store in sessionStorage so we don't track again
            sessionStorage.setItem('tracked_referral', refCode);
            // Also store for potential signup conversion tracking
            sessionStorage.setItem('referral_code_for_signup', refCode);
            console.log('Referral visit tracked:', data.message);
          }
        }
      } catch (error) {
        console.error('Failed to track referral:', error);
      }
    };

    trackReferral();
  }, [location.search]);

  return null; // This component doesn't render anything
};

export default ReferralTracker;
